;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';
import { useIntersection } from 'react-use';

import cx from 'classnames';
import PropTypes from 'prop-types';

import carouselContext from 'components/ui/CarouselProvider/CarouselContext';
import PaginationDots from 'components/ui/PaginationDots';

import Image from './Image';
import Swiper from './Swiper';

import styles from './FlipDeck.module.scss';

const Deck = ({
    flushTop = false,
    flushBottom = false,
    isLight = false,
    isCreamHeavy = false,
}) => {
    const ref = useRef(null);

    const [isForward, setIsForward] = useState(true);
    const [isInView, setIsInView] = useState(false);

    const cc = useContext(carouselContext);

    const intRatio = 0.5;
    const intersection = useIntersection(ref, {
        root: null,
        rootMargin: '0px',
        threshold: intRatio,
    });

    useEffect(() => {
        intersection && intersection.intersectionRatio > intRatio
            ? setIsInView(true)
            : setIsInView(false);
    }, [intersection]);

    const handleNextSlide = useCallback(() => {
        setIsForward(true);
        cc.nextSlide();
    }, [cc, setIsForward]);

    const handlePrevSlide = useCallback(() => {
        setIsForward(false);
        cc.nextSlide();
    }, [cc, setIsForward]);

    const handleSelectSlide = useCallback(
        index => {
            setIsForward(index > cc.activeIndex);
            cc.goToSlide(index);
        },
        [cc]
    );

    const handleKeydown = useCallback(() => {
        const rightArrow = event.keyCode === 39;
        const leftArrow = event.keyCode === 37;

        rightArrow === true && isInView && handlePrevSlide();
        leftArrow === true && isInView && handleNextSlide();
    }, [handleNextSlide, handlePrevSlide, isInView]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeydown, false);
        return () => {
            document.removeEventListener('keydown', handleKeydown, false);
        };
    }, [handleKeydown]);

    return (
        <section
            ref={ref}
            className={cx(styles.root, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
                [styles.light]: isLight,
                [styles.isCreamHeavy]: isCreamHeavy,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.col}>
                    <Swiper
                        className={styles.mediaWrapper}
                        tap={handlePrevSlide}
                        next={handleNextSlide}
                        prev={handlePrevSlide}
                        mouse
                    >
                        {cc.slides?.map((slide, i) => (
                            <Image
                                key={i}
                                {...slide}
                                isTop={cc.activeIndex === i}
                                // Check if last slide
                                isMiddle={
                                    cc.activeIndex < cc.totalSlides - 1
                                        ? cc.activeIndex + 1 === i
                                        : cc.activeIndex - 2 === i
                                }
                                // Check if last slide
                                isBottom={
                                    cc.activeIndex > 0
                                        ? cc.activeIndex - 1 === i
                                        : cc.activeIndex + 2 === i
                                }
                                isPrev={cc.prevIndex === i}
                                isForward={isForward}
                                alt={slide.image?.description || ''}
                                caption={slide.caption}
                            />
                        ))}
                    </Swiper>
                    <nav className={styles.nav}>
                        <PaginationDots
                            className={styles.dots}
                            count={cc.totalSlides}
                            activeIndex={cc.activeIndex}
                            onSelect={handleSelectSlide}
                        />
                    </nav>
                </div>
            </div>
        </section>
    );
};

Deck.propTypes = {
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    isLight: PropTypes.bool,
    isCreamHeavy: PropTypes.bool,
};

export default Deck;
